import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React from 'react'
import { useTranslation } from 'react-i18next';

function ULMGroupWarning(props) {
    const { t, i18n } = useTranslation();
  return (
    <>
    <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
        <MDBIcon
            fas
            icon="exclamation-triangle"
            className="me-3 fs-5 mt-1"
            color="warning"
        />
        <div>Please 'Enable' Include in UCC</div>
    </div>
    <MDBModalFooter>
       
        <MDBBtn onClick={(e) => {
            props.onClose(e);

        }}>{t("ok")}</MDBBtn>
    </MDBModalFooter>
</>
  )
}

export default ULMGroupWarning
